import React from 'react';
import { Button, Spin } from 'antd';
import 'react-toastify/dist/ReactToastify.css';
import logo from '@assets/images/sage-logo-login.png';
import { useHistory } from 'react-router-dom';
import { Navigation } from '@constants/Navigation';
import auth from '@services/api/auth';
import { toast } from 'react-toastify';

import './saml-auth.scss';
import { AppContext } from '@layouts/AppRouter';

const SamlAuth = () => {
  const history = useHistory();
  const tokenContext = React.useContext(AppContext);

  React.useEffect(() => {
    setTimeout(() => {
      startSaml();
    }, 1000);
  }, []);

  const startSaml = async () => {
    const obj = {};
    try {
      const { accessToken } = await auth.login(obj);
      if (accessToken) {
        tokenContext.setToken(accessToken);
      }
      toast.success('Welcome to Sota');
      history.push(Navigation.Main);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="main-login">
      <div className="saml">
        <img className="login-logo" src={logo} alt="Logo Sagem" />
        <span>Welcome to Sota</span>
        <Spin size="large" />
      </div>
    </div>
  );
};

export default SamlAuth;
